/* eslint-disable */
export default {
    sidebar_my_assessments: "Invitations",
    sidebar_welcome: "Welcome",
    sidebar_logout_could_not_logout: "Could not logout",
    sidebar_logout_logout_text: "Log out",
    sidebar_update_personal_details: "Personal profile",
    sidebar_feature_toggles_menu_item: "Feature toggles",
    sidebar_reports_menu_item: "Reports"
};
